/* eslint-disable react-refresh/only-export-components */
import { createContext, useState, useCallback } from "react";

import { APP_STATES } from "shared/enum";
import LoadingOverlay from "components/LoadingOverlay";

import type { ThemeMode } from "types/app";
import type { Dispatch, SetStateAction } from "react";

type AppContextType = {
  themeMode: ThemeMode;
  appLoadingState: APP_STATES;
  setThemeMode: Dispatch<SetStateAction<ThemeMode>>;
  setAppLoadingState: Dispatch<SetStateAction<APP_STATES>>;
  showLoadingOverlay: () => void;
  hideLoadingOverlay: () => void;
};

export const AppContext = createContext<AppContextType>({
  /* eslint-disable */
  themeMode: "dark",
  appLoadingState: APP_STATES.UNLOADED,
  // @ts-ignore
  setThemeMode: (state: ThemeMode | ((prev: ThemeMode) => ThemeMode)) => {},
  // @ts-ignore
  setAppLoadingState: (state: AppLoadingState | ((prev: AppLoadingState) => AppLoadingState)) => {},
  showLoadingOverlay: () => {},
  hideLoadingOverlay: () => {},
  /* eslint-enable */
});

export type AppProviderProps = {
  children?: React.ReactNode;
};

export function AppProvider({ children }: AppProviderProps) {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [themeMode, setThemeMode] = useState<ThemeMode>("dark");

  const [appLoadingState, setAppLoadingState] = useState<APP_STATES>(APP_STATES.UNLOADED);

  const showLoadingOverlay = useCallback(() => setIsLoading(true), []);
  const hideLoadingOverlay = useCallback(() => setIsLoading(false), []);

  return (
    <AppContext.Provider
      value={{
        themeMode,
        appLoadingState,
        setThemeMode,
        setAppLoadingState,
        showLoadingOverlay,
        hideLoadingOverlay,
      }}
    >
      <LoadingOverlay loading={isLoading} />
      {children}
    </AppContext.Provider>
  );
}
